// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=\"0 0 200 200\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cfilter id=\"noiseFilter\"%3E%3CfeTurbulence type=\"fractalNoise\" baseFrequency=\"2\" numOctaves=\"3\" stitchTiles=\"stitch\"/%3E%3C/filter%3E%3Crect width=\"100%25\" height=\"100%25\" filter=\"url%28%23noiseFilter%29\"/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html.dark {
  background: var(--site-background, #050505);
  color: var(--site-foreground, #FFFFFF);
}

body {
  font-family: var(--font-body, Arial, sans-serif);
  background: var(--site-background, #050505);
  color: var(--site-body-color, var(--site-foreground, #FFFFFF));
  overflow-x: hidden;
  line-height: 1.6;
  font-size: calc(1rem * var(--body-text-scale, 1));
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading, Arial, sans-serif);
  color: var(--site-heading-color, #FFFFFF);
}

.font-heading {
  font-family: var(--font-heading, Arial, sans-serif);
}

.font-mono {
  font-family: 'JetBrains Mono', monospace;
}

.glass {
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  background: rgba(10, 10, 10, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.glow-red {
  box-shadow: 0 0 30px -5px rgba(225, 29, 46, 0.3);
}

.glow-red-strong {
  box-shadow: 0 0 40px rgba(225, 29, 46, 0.6);
}

.text-shadow-red {
  text-shadow: 0 0 20px rgba(225, 29, 46, 0.5);
}

.gradient-hero {
  background: radial-gradient(circle at center, #1a0505 0%, #050505 100%);
}

.tracing-beam {
  position: relative;
  overflow: hidden;
}

.tracing-beam::before {
  content: '';
  position: absolute;
  inset: 0;
  padding: 1px;
  background: linear-gradient(to bottom, rgba(225, 29, 46, 0.5), transparent);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  border-radius: 24px;
  z-index: -1;
  pointer-events: none;
}

/* Smooth scroll */
html.lenis {
  height: auto;
}

.lenis.lenis-smooth {
  scroll-behavior: auto;
}

.lenis.lenis-smooth [data-lenis-prevent] {
  overscroll-behavior: contain;
}

.lenis.lenis-stopped {
  overflow: hidden;
}

.lenis.lenis-scrolling iframe {
  pointer-events: none;
}

/* Noise texture overlay */
.noise {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.03;
  z-index: 100;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.detail-page-shell {
  padding-top: calc(5rem + var(--space-card, 1rem));
  padding-bottom: var(--space-section, 4rem);
}

.detail-page-container {
  max-width: 72rem;
  margin: 0 auto;
  padding-left: 1rem;
  padding-right: 1rem;
}

.detail-page-backlink {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.68);
  transition: color 0.2s ease;
}

.detail-page-backlink:hover {
  color: var(--site-primary, #E11D2E);
}

.detail-page-card {
  border-radius: clamp(1.5rem, 2vw, 2rem);
  overflow: hidden;
}

.detail-page-title {
  font-family: var(--font-heading, Arial, sans-serif);
  font-size: calc(var(--type-title, clamp(1.875rem, 4vw, 3.25rem)) * var(--section-title-scale, 1));
  font-weight: 900;
  line-height: 0.98;
  letter-spacing: -0.03em;
  color: var(--site-heading-color, #FFFFFF);
}

.detail-page-body {
  font-size: calc(var(--type-body-lg, 1.125rem) * var(--body-text-scale, 1));
  color: var(--site-body-color, rgba(255, 255, 255, 0.78));
}

.detail-page-meta {
  color: var(--site-muted-color, rgba(255, 255, 255, 0.62));
  font-size: calc(0.95rem * var(--small-text-scale, 1));
}

@media (max-width: 767px) {
  .noise {
    opacity: 0.015;
  }

  .detail-page-shell {
    padding-top: 6rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .animate-float,
  .animate-pulse-glow {
    animation: none !important;
  }

  .noise {
    display: none;
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #0A0A0A;
}

::-webkit-scrollbar-thumb {
  background: #E11D2E;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #ff1d35;
}

/* Animations */
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

@keyframes pulse-glow {
  0%, 100% { box-shadow: 0 0 20px rgba(225, 29, 46, 0.3); }
  50% { box-shadow: 0 0 40px rgba(225, 29, 46, 0.6); }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-pulse-glow {
  animation: pulse-glow 2s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;EAChD,2CAA2C;EAC3C,8DAA8D;EAC9D,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,mDAAmD;EACnD,yCAAyC;AAC3C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2EAA2E;EAC3E,8EAA8E;EAE9E,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,yDAAsU;AACxU;;AAEA;EACE,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,iGAAiG;EACjG,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,0EAA0E;EAC1E,wDAAwD;AAC1D;;AAEA;EACE,yDAAyD;EACzD,qDAAqD;AACvD;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml.dark {\n  background: var(--site-background, #050505);\n  color: var(--site-foreground, #FFFFFF);\n}\n\nbody {\n  font-family: var(--font-body, Arial, sans-serif);\n  background: var(--site-background, #050505);\n  color: var(--site-body-color, var(--site-foreground, #FFFFFF));\n  overflow-x: hidden;\n  line-height: 1.6;\n  font-size: calc(1rem * var(--body-text-scale, 1));\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-heading, Arial, sans-serif);\n  color: var(--site-heading-color, #FFFFFF);\n}\n\n.font-heading {\n  font-family: var(--font-heading, Arial, sans-serif);\n}\n\n.font-mono {\n  font-family: 'JetBrains Mono', monospace;\n}\n\n.glass {\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  background: rgba(10, 10, 10, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.glow-red {\n  box-shadow: 0 0 30px -5px rgba(225, 29, 46, 0.3);\n}\n\n.glow-red-strong {\n  box-shadow: 0 0 40px rgba(225, 29, 46, 0.6);\n}\n\n.text-shadow-red {\n  text-shadow: 0 0 20px rgba(225, 29, 46, 0.5);\n}\n\n.gradient-hero {\n  background: radial-gradient(circle at center, #1a0505 0%, #050505 100%);\n}\n\n.tracing-beam {\n  position: relative;\n  overflow: hidden;\n}\n\n.tracing-beam::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  padding: 1px;\n  background: linear-gradient(to bottom, rgba(225, 29, 46, 0.5), transparent);\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  border-radius: 24px;\n  z-index: -1;\n  pointer-events: none;\n}\n\n/* Smooth scroll */\nhtml.lenis {\n  height: auto;\n}\n\n.lenis.lenis-smooth {\n  scroll-behavior: auto;\n}\n\n.lenis.lenis-smooth [data-lenis-prevent] {\n  overscroll-behavior: contain;\n}\n\n.lenis.lenis-stopped {\n  overflow: hidden;\n}\n\n.lenis.lenis-scrolling iframe {\n  pointer-events: none;\n}\n\n/* Noise texture overlay */\n.noise {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  opacity: 0.03;\n  z-index: 100;\n  background-image: url('data:image/svg+xml,%3Csvg viewBox=\"0 0 200 200\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cfilter id=\"noiseFilter\"%3E%3CfeTurbulence type=\"fractalNoise\" baseFrequency=\"2\" numOctaves=\"3\" stitchTiles=\"stitch\"/%3E%3C/filter%3E%3Crect width=\"100%25\" height=\"100%25\" filter=\"url(%23noiseFilter)\"/%3E%3C/svg%3E');\n}\n\n.detail-page-shell {\n  padding-top: calc(5rem + var(--space-card, 1rem));\n  padding-bottom: var(--space-section, 4rem);\n}\n\n.detail-page-container {\n  max-width: 72rem;\n  margin: 0 auto;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.detail-page-backlink {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: rgba(255, 255, 255, 0.68);\n  transition: color 0.2s ease;\n}\n\n.detail-page-backlink:hover {\n  color: var(--site-primary, #E11D2E);\n}\n\n.detail-page-card {\n  border-radius: clamp(1.5rem, 2vw, 2rem);\n  overflow: hidden;\n}\n\n.detail-page-title {\n  font-family: var(--font-heading, Arial, sans-serif);\n  font-size: calc(var(--type-title, clamp(1.875rem, 4vw, 3.25rem)) * var(--section-title-scale, 1));\n  font-weight: 900;\n  line-height: 0.98;\n  letter-spacing: -0.03em;\n  color: var(--site-heading-color, #FFFFFF);\n}\n\n.detail-page-body {\n  font-size: calc(var(--type-body-lg, 1.125rem) * var(--body-text-scale, 1));\n  color: var(--site-body-color, rgba(255, 255, 255, 0.78));\n}\n\n.detail-page-meta {\n  color: var(--site-muted-color, rgba(255, 255, 255, 0.62));\n  font-size: calc(0.95rem * var(--small-text-scale, 1));\n}\n\n@media (max-width: 767px) {\n  .noise {\n    opacity: 0.015;\n  }\n\n  .detail-page-shell {\n    padding-top: 6rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .animate-float,\n  .animate-pulse-glow {\n    animation: none !important;\n  }\n\n  .noise {\n    display: none;\n  }\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0A0A0A;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #E11D2E;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #ff1d35;\n}\n\n/* Animations */\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-20px); }\n}\n\n@keyframes pulse-glow {\n  0%, 100% { box-shadow: 0 0 20px rgba(225, 29, 46, 0.3); }\n  50% { box-shadow: 0 0 40px rgba(225, 29, 46, 0.6); }\n}\n\n.animate-float {\n  animation: float 6s ease-in-out infinite;\n}\n\n.animate-pulse-glow {\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
